"use strict";
/**
 * Baseball per-button pricing configuration.
 *
 * The button metadata table and hit-type → slippage mapping live here; the
 * generic stepper / modal / pin / hint machinery lives in ../sport/pricing.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.BASEBALL_SPORT_BUTTONS = exports.MAIN_BUTTONS = exports.getAskPrice = void 0;
exports.isCombinedMode = isCombinedMode;
exports.getButtonHintText = getButtonHintText;
exports.refreshAllHints = refreshAllHints;
exports.setupButtonPriceSteppers = setupButtonPriceSteppers;
exports.getPinnedPrice = getPinnedPrice;
exports.setupSetToAskButton = setupSetToAskButton;
const state_1 = require("../../../state");
const ui_1 = require("../../../ui");
const pricing_1 = require("../sport/pricing");
var pricing_2 = require("../sport/pricing");
Object.defineProperty(exports, "getAskPrice", { enumerable: true, get: function () { return pricing_2.getAskPrice; } });
/** Full table of the 16 main baseball buttons (8 offense + 8 defense, 2 sides each). */
exports.MAIN_BUTTONS = [
    // Offense A
    { key: "single_a", side: "yes", hitType: "single", isDefense: false, btnId: "bb-single-a", hintId: "bb-single-a-hint", stepperId: "bb-single-a-stepper", incId: "bb-single-a-inc", decId: "bb-single-a-dec", setId: "bb-single-a-set" },
    { key: "double_a", side: "yes", hitType: "double", isDefense: false, btnId: "bb-dbl-a", hintId: "bb-dbl-a-hint", stepperId: "bb-dbl-a-stepper", incId: "bb-dbl-a-inc", decId: "bb-dbl-a-dec", setId: "bb-dbl-a-set" },
    { key: "triple_a", side: "yes", hitType: "triple", isDefense: false, btnId: "bb-trpl-a", hintId: "bb-trpl-a-hint", stepperId: "bb-trpl-a-stepper", incId: "bb-trpl-a-inc", decId: "bb-trpl-a-dec", setId: "bb-trpl-a-set" },
    { key: "hr_a", side: "yes", hitType: "hr", isDefense: false, btnId: "bb-hr-a", hintId: "bb-hr-a-hint", stepperId: "bb-hr-a-stepper", incId: "bb-hr-a-inc", decId: "bb-hr-a-dec", setId: "bb-hr-a-set" },
    // Offense B
    { key: "single_b", side: "no", hitType: "single", isDefense: false, btnId: "bb-single-b", hintId: "bb-single-b-hint", stepperId: "bb-single-b-stepper", incId: "bb-single-b-inc", decId: "bb-single-b-dec", setId: "bb-single-b-set" },
    { key: "double_b", side: "no", hitType: "double", isDefense: false, btnId: "bb-dbl-b", hintId: "bb-dbl-b-hint", stepperId: "bb-dbl-b-stepper", incId: "bb-dbl-b-inc", decId: "bb-dbl-b-dec", setId: "bb-dbl-b-set" },
    { key: "triple_b", side: "no", hitType: "triple", isDefense: false, btnId: "bb-trpl-b", hintId: "bb-trpl-b-hint", stepperId: "bb-trpl-b-stepper", incId: "bb-trpl-b-inc", decId: "bb-trpl-b-dec", setId: "bb-trpl-b-set" },
    { key: "hr_b", side: "no", hitType: "hr", isDefense: false, btnId: "bb-hr-b", hintId: "bb-hr-b-hint", stepperId: "bb-hr-b-stepper", incId: "bb-hr-b-inc", decId: "bb-hr-b-dec", setId: "bb-hr-b-set" },
    // Defense A
    { key: "strikeout_a", side: "yes", hitType: "strikeout", isDefense: true, btnId: "bb-ko-a", hintId: "bb-ko-a-hint", stepperId: "bb-ko-a-stepper", incId: "bb-ko-a-inc", decId: "bb-ko-a-dec", setId: "bb-ko-a-set" },
    { key: "out_a", side: "yes", hitType: "out", isDefense: true, btnId: "bb-out-a", hintId: "bb-out-a-hint", stepperId: "bb-out-a-stepper", incId: "bb-out-a-inc", decId: "bb-out-a-dec", setId: "bb-out-a-set" },
    { key: "double_play_a", side: "yes", hitType: "double_play", isDefense: true, btnId: "bb-dp-a", hintId: "bb-dp-a-hint", stepperId: "bb-dp-a-stepper", incId: "bb-dp-a-inc", decId: "bb-dp-a-dec", setId: "bb-dp-a-set" },
    { key: "triple_play_a", side: "yes", hitType: "triple_play", isDefense: true, btnId: "bb-tp-a", hintId: "bb-tp-a-hint", stepperId: "bb-tp-a-stepper", incId: "bb-tp-a-inc", decId: "bb-tp-a-dec", setId: "bb-tp-a-set" },
    // Defense B
    { key: "strikeout_b", side: "no", hitType: "strikeout", isDefense: true, btnId: "bb-ko-b", hintId: "bb-ko-b-hint", stepperId: "bb-ko-b-stepper", incId: "bb-ko-b-inc", decId: "bb-ko-b-dec", setId: "bb-ko-b-set" },
    { key: "out_b", side: "no", hitType: "out", isDefense: true, btnId: "bb-out-b", hintId: "bb-out-b-hint", stepperId: "bb-out-b-stepper", incId: "bb-out-b-inc", decId: "bb-out-b-dec", setId: "bb-out-b-set" },
    { key: "double_play_b", side: "no", hitType: "double_play", isDefense: true, btnId: "bb-dp-b", hintId: "bb-dp-b-hint", stepperId: "bb-dp-b-stepper", incId: "bb-dp-b-inc", decId: "bb-dp-b-dec", setId: "bb-dp-b-set" },
    { key: "triple_play_b", side: "no", hitType: "triple_play", isDefense: true, btnId: "bb-tp-b", hintId: "bb-tp-b-hint", stepperId: "bb-tp-b-stepper", incId: "bb-tp-b-inc", decId: "bb-tp-b-dec", setId: "bb-tp-b-set" },
];
/** Map a baseball button's hit type to its factor-scaled slippage. */
function getHitSlippage(meta, factor) {
    return meta.isDefense
        ? (0, ui_1.getBaseballDefenseSlippage)(meta.hitType, factor)
        : (0, ui_1.getBaseballSlippage)(meta.hitType, factor);
}
/** Adapt a baseball button's metadata to the sport-generic contract. */
function toSportMeta(meta) {
    return {
        key: meta.key,
        btnId: meta.btnId,
        hintId: meta.hintId,
        stepperId: meta.stepperId,
        incId: meta.incId,
        decId: meta.decId,
        setId: meta.setId,
        side: meta.side,
        getSlippage: (factor) => getHitSlippage(meta, factor),
    };
}
/**
 * The eight MISC buttons (top fixed-zero + bottom scaled; offense + defense,
 * 2 sides each) in sport-generic form. MISC 0 slippage is 0 at every factor,
 * so pinning sets it to the raw low ask — mirroring basketball's MISC. Scaled
 * MISC pins to ask + its factor-scaled slippage, like the main buttons.
 */
const MISC_BUTTONS = [
    { key: "misc_zero_off_a", side: "yes", btnId: "bb-misc-top-a", hintId: "bb-misc-top-a-slip", stepperId: "bb-misc-top-a-stepper", incId: "bb-misc-top-a-inc", decId: "bb-misc-top-a-dec", setId: "bb-misc-top-a-set", getSlippage: () => 0 },
    { key: "misc_zero_off_b", side: "no", btnId: "bb-misc-top-b", hintId: "bb-misc-top-b-slip", stepperId: "bb-misc-top-b-stepper", incId: "bb-misc-top-b-inc", decId: "bb-misc-top-b-dec", setId: "bb-misc-top-b-set", getSlippage: () => 0 },
    { key: "misc_zero_def_a", side: "yes", btnId: "bb-misc-def-top-a", hintId: "bb-misc-def-top-a-slip", stepperId: "bb-misc-def-top-a-stepper", incId: "bb-misc-def-top-a-inc", decId: "bb-misc-def-top-a-dec", setId: "bb-misc-def-top-a-set", getSlippage: () => 0 },
    { key: "misc_zero_def_b", side: "no", btnId: "bb-misc-def-top-b", hintId: "bb-misc-def-top-b-slip", stepperId: "bb-misc-def-top-b-stepper", incId: "bb-misc-def-top-b-inc", decId: "bb-misc-def-top-b-dec", setId: "bb-misc-def-top-b-set", getSlippage: () => 0 },
    { key: "misc_scaled_off_a", side: "yes", btnId: "bb-misc-bottom-a", hintId: "bb-misc-bottom-a-slip", stepperId: "bb-misc-bottom-a-stepper", incId: "bb-misc-bottom-a-inc", decId: "bb-misc-bottom-a-dec", setId: "bb-misc-bottom-a-set", getSlippage: ui_1.getBaseballMiscSlippage },
    { key: "misc_scaled_off_b", side: "no", btnId: "bb-misc-bottom-b", hintId: "bb-misc-bottom-b-slip", stepperId: "bb-misc-bottom-b-stepper", incId: "bb-misc-bottom-b-inc", decId: "bb-misc-bottom-b-dec", setId: "bb-misc-bottom-b-set", getSlippage: ui_1.getBaseballMiscSlippage },
    { key: "misc_scaled_def_a", side: "yes", btnId: "bb-misc-def-bottom-a", hintId: "bb-misc-def-bottom-a-slip", stepperId: "bb-misc-def-bottom-a-stepper", incId: "bb-misc-def-bottom-a-inc", decId: "bb-misc-def-bottom-a-dec", setId: "bb-misc-def-bottom-a-set", getSlippage: ui_1.getBaseballMiscSlippage },
    { key: "misc_scaled_def_b", side: "no", btnId: "bb-misc-def-bottom-b", hintId: "bb-misc-def-bottom-b-slip", stepperId: "bb-misc-def-bottom-b-stepper", incId: "bb-misc-def-bottom-b-inc", decId: "bb-misc-def-bottom-b-dec", setId: "bb-misc-def-bottom-b-set", getSlippage: ui_1.getBaseballMiscSlippage },
];
/** The 24 baseball buttons with per-button pricing (16 main + 8 MISC). */
exports.BASEBALL_SPORT_BUTTONS = [
    ...exports.MAIN_BUTTONS.map(toSportMeta),
    ...MISC_BUTTONS,
];
// ---------------------------------------------------------------------------
// Public surface (delegates to the sport-generic engine)
// ---------------------------------------------------------------------------
/** Returns true when a sport layout is showing AND manual price mode is active. */
function isCombinedMode() {
    return (0, ui_1.isCombinedPricingMode)((0, state_1.getState)().tradingSettings);
}
/**
 * Get the effective price hint text for a main button.
 * Combined mode → shows manual price or ask fallback in ¢.
 * Otherwise      → shows slippage %.
 */
function getButtonHintText(meta) {
    return (0, pricing_1.getSportButtonHintText)(toSportMeta(meta));
}
/**
 * Refresh the hint/label on every main baseball button.
 * In combined mode shows manual prices (¢); otherwise shows slippage (%).
 */
function refreshAllHints() {
    (0, pricing_1.refreshSportButtonHints)(exports.BASEBALL_SPORT_BUTTONS);
}
/**
 * Wire up the +/•/− stepper buttons for all baseball buttons with per-button
 * pricing (16 main + 8 MISC).
 * The middle "•" button opens the price modal for that button.
 */
function setupButtonPriceSteppers() {
    (0, pricing_1.setupSportPriceSteppers)(exports.BASEBALL_SPORT_BUTTONS);
}
/**
 * Compute the "pin" price for a main button: the lowest ask price for that
 * side PLUS the factor-adjusted slippage for that button's hit type, clamped
 * to [1, 99].
 */
function getPinnedPrice(meta, factor) {
    return (0, pricing_1.getSportPinnedPrice)(toSportMeta(meta), factor);
}
/**
 * Wire up the "Set all to Ask" button (📌) that populates every baseball
 * button with per-button pricing (all MISC buttons included) with the ask
 * price + factor-adjusted slippage for its side, then refreshes all hints.
 * Prices for other sports' buttons are preserved.
 */
function setupSetToAskButton() {
    (0, pricing_1.setupSportSetToAskButton)("baseball-set-to-ask-btn", exports.BASEBALL_SPORT_BUTTONS, refreshAllHints);
}
